

export enum ExecutionEngineType {
 
    AplosNcaDataCleaning = "aplos_nca_data_cleaning",
    AplosNcaProfileService = "aplos_nca_profile_service",
    AplosNcaCalcEngine = "aplos_nca_calc_engine",
    AplosNcaAnalysisEngine = "aplos_nca_analysis_engine",
    AplosNcaServices = "aplos_nca_services",
    AplosNcaCustomCalculations = "aplos_nca_custom_calculations",
    AplosNcaCustomPlotting = "aplos_nca_custom_plots",
    AplosNcaCustomTables = "aplos_nca_custom_tables",
    AplosNcaCustomReport = "aplos_nca_custom_report"
}